/**
 * LES MOTS QUE LE LEXIQUE CLIENT v0.1 RETIRE (05/10/2026, DEV-2311), famille
 * par famille : commun à la page de l'étude, à sa page d'aide, au rapport PDF
 * et aux textes du moteur. Les balayages des pages (`*.balayage.spec.ts`,
 * `PageBuildingOptimTurpeV2Aide.spec.ts`) les cherchent dans le texte rendu.
 */

/** Un mot entier, accents compris (`\b` ne connaît pas « é »). */
export function mot(alternatives: string): RegExp {
    return new RegExp(
        `(?<![\\p{L}\\d_])(?:${alternatives})(?![\\p{L}\\d_])`,
        "giu"
    )
}

/** Les mots que le lexique client v0.1 retire, famille par famille. */
export const LEXIQUE_CLIENT: [string, RegExp][] = [
    ["« ferme » ou « démontrable »", mot("fermes?|démontrables?")],
    [
        "au lieu de « la plage qui fixe la puissance »",
        mot("motrices?|dimensionnantes?|plage pilote"),
    ],
    ["« classe » au sens de plage", mot("classes?")],
    [
        "au lieu de « puissances souscrites, plage par plage »",
        mot("d[ée]nivel[ée]s?"),
    ],
    [
        "au lieu de « relevés »",
        mot(
            "au pas de|pas de (?:dix|10) min(?:utes)?|pas de temps|pas mesurés"
        ),
    ],
    ["valeur brute à tiret bas", /[\p{L}\d]+_[\p{L}\d_]+/gu],
    // « pic isolé » reste un mot de la page : c'est une forme de pointe, pas la pointe.
    [
        "au lieu de « la pointe mesurée »",
        mot("pic mesuré|couvrir le pic|couverture du pic"),
    ],
    // Revue du 08/10/2026 (R2) : « Couvrir la pointe » se confondait avec la
    // plage Pointe ; le scénario s'appelle « Couvrir les dépassements ».
    [
        "au lieu de « Couvrir les dépassements »",
        mot("couvrir la pointe|couverture de la pointe"),
    ],
]

/**
 * La règle de croissance des postes (série UX du témoin, 15/10/2026, 2.1
 * point 8) : une seule source pour la note sous le graphique des puissances
 * (poste « relevée ») et pour la preuve, qui la recopiait.
 *
 * Relecture de L-G, reprise dans L-B : un C4 n'a pas de poste de pointe
 * (PTE) ; sa chaîne part des heures pleines de saison haute (HPH). La phrase
 * avec la pointe reste celle du C2 et, à défaut de segment lisible, celle
 * d'avant.
 */
export function regleCroissanceDesPostes(
    segment: string | null | undefined
): string {
    const debut =
        segment === "C4"
            ? "des heures pleines de saison haute (HPH)"
            : "des heures de pointe (PTE)"
    return `Les puissances souscrites croissent ${debut} aux heures creuses de saison basse (HCB) : un poste peu chargé garde au moins la puissance de celui qui le précède.`
}
